let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "结算总表",
  },
];
// 结算总表详表 - 面包屑
pageConfig.listBreadCrumbItem = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "结算总表",
    router: "summaryTable",
  },
  {
    type: "title",
    name: "结算总表详表",
  },
]

// 列表展示项
pageConfig.listColumns = [
  {
    label: "分账订单号",
    props: "dealName",
    minWidth: 200,
  },
  {
    label: "充电订单号",
    props: "stationNumber",
    minWidth: 200,
  },
  {
    label: "站点名称",
    props: "pileNumber",
    minWidth: 200,
  },
  {
    label: "充电桩编号",
    props: "repairNumber",
    minWidth: 140,
  },
  {
    label: "用户手机号",
    props: "totalChargeCount",
    minWidth: 140,
  },
  {
    label: "订单类型",
    props: "orderNumber",
    minWidth: 140,
  },
  {
    label: "开始时间",
    props: "userNumber",
    minWidth: 140,
  },
  {
    label: "结束时间",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "充电时长",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "支付方式",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "充电电量（度）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "预付金额（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "订单金额（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "订单电费（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "订单服务费（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "结算金额（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "结算电费（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "结算服务费（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "在线支付（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "钱包余额支付（元）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "度电支付（度）",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "减免电费",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "减免服务费",
    props: "totalFee",
    minWidth: 140,
  },
  {
    label: "支付流水号",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "退款总金额",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "分成时间",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "提现时间",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "结算状态",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "分成方式",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "分成比例",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "分成费用",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "开票状态",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "开票时间",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "开票税费",
    props: "totalFee",
    minWidth: 240,
  },
  {
    label: "交易费",
    props: "totalFee",
    minWidth: 240,
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
  herderStyle: {
    background: "#FAFAFA",
    color: "#8F9BB3",
    fontSize: "14px",
    fontFamily: "PingFangSC-Medium, PingFang SC",
  },
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [2, 3, 4, 5, 10, 20, 50, 100],
};

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "dealerDetail",
};

// 路由
pageConfig.listRouter = "dealerManageList";
pageConfig.reportRouter = "dealerReportDetail";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "结算总表",
    router: "summaryTable",
  },
  {
    type: "router",
    name: "结算总表详表",
    router: "summaryDetail",
  },
  {
    type: "title",
    name: "结算订单详情",
  },
];

pageConfig.addRuleArr = [
  "dealName",
  "dealAbbrName",
  "organizeNo",
  "contactName",
  "contactPhone",
  "bankCard",
  "bankName",
  "bankCode",
];

pageConfig.editRuleArr = [
  "dealName",
  "dealAbbrName",
  "organizeNo",
  "contactName",
  "contactPhone",
];

pageConfig.formRules = {
  dealName: [
    {
      required: true,
      message: "请填写公司名称",
      trigger: "blur",
    },
  ],
  dealAbbrName: [
    {
      required: true,
      message: "请填写公司简称",
      trigger: "blur",
    },
  ],
  organizeNo: [
    {
      required: true,
      message: "请填写社会统一组织机构代码",
      trigger: "blur",
    },
  ],
  contactName: [
    {
      required: true,
      message: "请填写公司联系人1",
      trigger: "blur",
    },
  ],
  contactPhone: [
    {
      required: true,
      message: "请填写联系方式",
      trigger: "blur",
    },
  ],
  bankCard: [
    {
      required: true,
      message: "请填写收款方银行卡号",
      trigger: "blur",
    },
  ],
  bankName: [
    {
      required: true,
      message: "请填写收款方用户名",
      trigger: "blur",
    },
  ],
  
  bankCode: [
    {
      required: true,
      message: "请填开户行编号",
      trigger: "blur",
    },
  ],
  serviceTel: [
    {
      required: true,
      message: "请填写客服电话",
      trigger: "blur",
    },
  ],
  turnoverMerchantCode: [
    {
      required: true,
      message: "请填写微信商户编号",
      trigger: "blur",
    },
  ],
  wxMerchantName: [
    {
      required: true,
      message: "请填写微信商户全称",
      trigger: "blur",
    },
  ],
};

export default pageConfig;
